var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ref-subtitle", [_vm._v("Coming Soon.")]),
      _c("ref-body-text", { staticClass: "mb-4" }, [
        _vm._v(" This feature is not yet released but is planned. ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }